import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, forwardRef, ElementRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { MatPaginator, MatSort, MatDialog } from "@angular/material";
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { Actions } from '@ngrx/effects';

import { ModuleConfiguration } from '../vocabulary.module.config';
import { TileState } from '../../pillar/dashboard/store/state/TileState';
import { StoreDataSource } from '../../core/services/StoreDataSource';
import { CodeSystemVersionListModel } from '../models/CodeSystemVersionListModel';
import { CodeSystemVersionDashboardModel } from '../models/CodeSystemVersionDashboardModel';
import { CodeSystemVersionSimpleExtractModel } from '../models/CodeSystemVersionSimpleExtractModel';
import * as fromStore from '../store/reducers';
import * as actions from '../../pillar/dashboard/store/actions';
import { SearchComponent } from '../../pillar/search/components/search.component';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';
import { AddCodeSystemDialogComponent } from './add-code-system-dialog.component';
import { TileComponent } from '../../pillar/dashboard/components/tile.component';
import { TileContainer } from '../../pillar/dashboard/services/TileContainer';
import { VocabularyService } from '../services/VocabularyService';
import { AppConfigurationService } from '../../core/services/AppConfigurationService';
import * as vocabularyActions from '../store/actions';

@Component({
  selector: 'brd-vocabulary-tile',
  providers: [{ provide: TileComponent, useExisting: forwardRef(() => VocabularyTileComponent) }],
  templateUrl: './vocabulary-tile.component.html',
  styleUrls: ['./vocabulary-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VocabularyTileComponent extends TileComponent implements OnInit, OnDestroy {

  loading: boolean;
  displayedColumns = ['codeSystemName', 'versionName','releaseDate','status','actions'];
  dataSource: StoreDataSource<CodeSystemVersionListModel>;
  loading$: Observable<boolean>;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  errors$: Observable<string[]>;
  accountActionLoading: Map<string, boolean> = new Map<string, boolean>();
  editPermission = 'VocabularyModule.CodeSystem:Edit';
  clearCachePermission = 'VocabularyModule.CodeSystem:ClearCache';
  exportPermission = 'VocabularyModule.CodeSystem:Export';
  showPastVersion = false;

  @ViewChild(MatPaginator)
  paginator: MatPaginator;
  @ViewChild(MatSort)
  sort: MatSort;
  @ViewChild(SearchComponent)
  search: SearchComponent;
  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;

  constructor(private store: Store<TileState<CodeSystemVersionListModel, CodeSystemVersionDashboardModel>>,
              private router: Router,
              private actions$: Actions,
              private dialog: MatDialog,
              private changeDetectorRef: ChangeDetectorRef,
              elementRef: ElementRef,
              private tileContainer: TileContainer,
              private vocabularyService: VocabularyService,
              private appConfigurationService: AppConfigurationService ) {
    super(elementRef);
    tileContainer.tileComponents.push(this);
  }

  ngOnInit() {
    this.errors$ = this.store.select(fromStore.getCodeSystemVersionListErrors);
    this.refreshDataSource();
    this.loading$ = this.store.select(fromStore.getCodeSystemVersionListLoading);
   
    this.actions$.ofType(vocabularyActions.CLEAR_VOCABULARY_CACHE_SUCCESS)
      .takeUntil(this.destroyed$)
      .subscribe((a: vocabularyActions.ClearVocabularyCacheSuccessAction) => {
        if (a.payload.success) {
          this.loading = false;
        } else {
          this.loading = false;
        }
        this.changeDetectorRef.markForCheck();
      });

  }

  selectItem(item: CodeSystemVersionListModel) {
    this.router.navigateByUrl('vocabulary-dashboard/' + item.key);
  }

  showAdd(): void {
    this.dialog.open(AddCodeSystemDialogComponent, {
      panelClass: 'customized-dialog',
      width: '648px'
    });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  toggleVersions(): void {
    this.showPastVersion = !this.showPastVersion;
    this.paginator.pageIndex = 0;
    this.refreshDataSource();
  }

  private refreshDataSource() {
    this.dataSource = new StoreDataSource<CodeSystemVersionListModel>(
      this.destroyed$,
      this.paginator,
      this.store,
      this.store.select(fromStore.getCodeSystemVersionList),
      this.store.select(fromStore.getCodeSystemVersionListTotalCount),
      this.store.select(fromStore.getCodeSystemVersionListLoading),
      (p, s, search) => new actions.QueryListAction ( ModuleConfiguration.moduleName,
        CodeSystemVersionListModel,
        {
          page: p.pageIndex,
          pageSize: p.pageSize,
          sort: s.active,
          sortDirection: s.direction,
          searchTerm: search.searchControl.value,
          loadLatest: !this.showPastVersion
        }),
      this.sort,
      this.search
    );
  }

  private exportVocabulary(type: string, codeSystemVersionListModel: CodeSystemVersionListModel): void {
    codeSystemVersionListModel.projectName = this.appConfigurationService.configuration.customerDisplayName;
    this.vocabularyService.exportCodeSystemVersion(type, codeSystemVersionListModel).take(1)
      .subscribe(r => {
        this.vocabularyService.openExtract(r.model.url, r.model);
      });;
  }

  clearCache() {
    this.loading = true;
    this.store.dispatch(new vocabularyActions.ClearVocabularyCacheAction());
  }

  
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/components/vocabulary-tile.component.ts